<!--
 * @Author: M.D.
 * @Date: 2019-12-31 11:13:30
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="glr-out-r">
    <ul class="glr-ul" v-if="gdsData.length !== 0">
      <li
        class="glr-item-li bShadow-5"
        @click="goToGdsDetail(i)"
        v-for="(i, index) in gdsData"
        :key="index"
      >
        <div class="gds-d-i-l">
          <div class="img-glr-img-w">
            <img
              :src="tImgUrl(i.image.split(',')[0])"
              class="image"
              :onerror="errImgDefault"
            />
          </div>
        </div>
        <div class="gds-d-i-r">
          <div class="gds-d-name">{{ i.name }}</div>
          <ul v-if="i.label" class="gds-d-label">
            <li class="gds-d-info" v-for="t in i.label.split(',')" :key="t">
              {{ t }}
            </li>
          </ul>
          <span class="gds-d-intro">{{ i.intro }}</span>
          <div class="gds-d-i-bottom">
            <span class="gds-d-i-curP">
              <span class="unit" v-if="i.isOnPay === 1">￥</span>
              {{ i.isOnPay !== 1 ? '价格面议' : getFinalPrice(i) }}
            </span>
            <span
              v-if="i.discountPrice !== -1 && i.isOnPay === 1"
              class="gds-d-i-orgP"
            >
              <span class="unit">￥</span>
              {{ i.price }}
            </span>
            <span class="gds-d-i-orgR">
              {{ goodInfo(i) }}
            </span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    gdsData: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '1',
    },
  },
  data() {
    return {
      innerFilter: null,

      curPage: 1,
      pageSize: 10,
      dataList: [],

      total: 10,
    }
  },
  computed: {},
  created() {},
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {},
  methods: {
    goToGdsDetail(i) {
      this.$router.push({
        name: 'productDetail',
        params: { prodId: i.id, type: this.type },
      })
    },
  },
  components: {},
}
</script>

<style lang="stylus">
.glr-out-r {
  margin-top: 20px;
  background-color: #ffffff;
  .glr-ul {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 20px 20px 10px;

    .glr-item-li {
      font-size: 14px;
      margin-bottom: 20px;
      box-sizing: border-box;
      height: 200px;
      display: flex;

      .gds-d-i-l {
        flex: 0 0 300px;
        margin: 0 30px 0 20px;

        .img-glr-img-w {
          flex: 0 0 300px;
          goods-img-wrapper();

          .image {
            goods-img-image();
            top: 20px;
            max-height: 160px;
          }
        }
      }

      .gds-d-i-r {
        flex: 1 1 auto;
        margin: 20px 0;
        position: relative;

        .gds-d-name {
          color: #333333;
          font-size: 20px;
        }

        .gds-d-label {
          margin-top: 12px;

          .gds-d-info {
            height: 20px;
            line-height: 20px;
            display: inline-block;
            margin-right: 12px;
            padding: 2px 8px 2px 8px;
            color: #31A826;
            border: 1px solid rgba(49, 168, 38, 1);
            opacity: 1;
            border-radius: 4px;
          }
        }

        .gds-d-intro {
          width: 100%;
          margin-top: 13px;
          font-size: 14px;
          color: #999999;
          display: block;
        }

        .gds-d-i-bottom {
          position: absolute;
          left: 0;
          bottom: 10px;
          width: 100%;

          .gds-d-i-curP {
            color: orange-color;
            margin-right: 12px;
            font-size: 24px;

            .unit {
              font-size: 18px;
            }
          }

          .gds-d-i-orgP {
            font-size: 18px;
            color: #999999;
            text-decoration: line-through;
          }

          .gds-d-i-orgR {
            float: right;
            margin-top: 12px;
            vertical-align: middle;
            font-size: 12px;
            height: 15px;
            line-height: 15px;
            margin-right: 25px;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
